import { get } from 'lodash';
import React, { useState } from 'react';
import { Nav } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link, Redirect, Route, Switch, useLocation } from "react-router-dom";
import ParticipationTableOnSteroids from '../profile/Offer/ParticipationTableOnSteroids';
import Instagram from './Instagram/Instagram';
import Tiktok from './Tiktok/Tiktok';
import Youtube from './Youtube/Youtube';
import Linkedin from './Linkedin/Linkedin';

const PATH = '/analytics';

// Tabs to match if the user goes to any
const REGEX_TABS = /^\/analytics(\/(instagram|tiktok|youtube|linkedin|campaign)(\W.*)?)$/gm;

const Analytics = ({ user }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const matchTabs = REGEX_TABS.test(location.pathname);
  const [state] = useState({
    path: matchTabs ? location.pathname : `${PATH}/instagram`
  });

  const socialUsernames = get(user, 'social') || {};
  const socialProfiles = get(user, 'social_profiles') || [];
  const getPlatform = (profiles, platform) => profiles.filter(profile => profile.platform === platform)[0] || {};

  return (
    <div className="home-page" id="analytics-page">
      <Nav
        className="navbar-secondary position-relative"
        bg="light"
        variant="tabs"
        defaultActiveKey={state.path} >
        {get(socialUsernames, 'inst.nickname') ?
          <Nav.Link as={Link} eventKey={`${PATH}/instagram`} to={`${PATH}/instagram`}>
            {t('influencers.common.instagram')}
          </Nav.Link> : null}
        {get(socialUsernames, 'tikt.nickname') ?
          <Nav.Link as={Link} eventKey={`${PATH}/tiktok`} to={`${PATH}/tiktok`}>
            {t('influencers.common.tiktok')}
          </Nav.Link> : null}
        {get(socialUsernames, 'yout.nickname') ?
          <Nav.Link as={Link} eventKey={`${PATH}/youtube`} to={`${PATH}/youtube`}>
            {t('influencers.common.youtube')}
          </Nav.Link> : null}
        {get(socialUsernames, 'link.nickname') ?
          <Nav.Link as={Link} eventKey={`${PATH}/linkedin`} to={`${PATH}/linkedin`}>
            {t('influencers.common.linkedin')}
          </Nav.Link> : null}
        <Nav.Link as={Link} eventKey={`${PATH}/campaigns`} to={`${PATH}/campaigns`}>
          {t('common.campaigns')}
        </Nav.Link>
      </Nav>

      <div>
        <Switch>

          <Route exact path={`${PATH}/instagram`}>
            <Instagram
              data={getPlatform(socialProfiles, 'instagram')} />
          </Route>

          <Route exact path={`${PATH}/tiktok`}>
            <Tiktok
              data={getPlatform(socialProfiles, 'tiktok')} />
          </Route>

          <Route exact path={`${PATH}/youtube`}>
            <Youtube
              data={getPlatform(socialProfiles, 'youtube')} />
          </Route>

          <Route exact path={`${PATH}/linkedin`}>
            <Linkedin
              data={getPlatform(socialProfiles, 'linkedin')} />
          </Route>

          <Route exact path={`${PATH}/campaigns`} >
            <ParticipationTableOnSteroids />
          </Route>

          <Redirect from={`${PATH}/*`} to={`${PATH}/instagram`} />
          <Redirect from={`${PATH}`} to={`${PATH}/instagram`} />

        </Switch>
      </div>
    </div >

  );
};

export default React.memo(Analytics);
